import Vue from "vue";
import axios from 'axios';

const version = 'v1';
const deleteUserApi = `${version}/User/delete`;
const updateUserApi = `${version}/User/update`;
const addUserApi = `${version}/User/add`;
const getAllUsersApi = `${version}/User/getAll`;
const canRegisterEmailApi = `${version}/User/canRegisterEmail`;
const checkTempPasswordApi = `${version}/User/checkTempPass`;

export const state = Vue.observable({
    users: [],
    usersCount: 0,
    jwt: null
});

export const mutations = {
    async getUsers(params = {}) {
        var res = await axios.post(`${getAllUsersApi}`, params);
        state.users = res.data.result.items;
        state.usersCount = res.data.result.totalCount;
    },
    async deleteUser({ id, businessId, tokenKey }) {
        await axios.post(`${deleteUserApi}`, { id, businessId, tokenKey });
        await this.getUsers();
    },
    async updateUser(user) {
        await axios.post(`${updateUserApi}`, user);
        await this.getUsers();
    },
    async addUser(user) {
        await axios.post(`${addUserApi}`, user);
        await this.getUsers();
    },
    async canRegisterEmail(registerEmailRequest) {
        return await axios.post(`${canRegisterEmailApi}`, registerEmailRequest);
    },
    async checkTempPassword(tempKey) {
        return await axios.post(`${checkTempPasswordApi}`, tempKey);
    },
};